/* ONLY · Contacto: el campo NÚMERO DE PEDIDO aparece sólo con el motivo de pedido
   (estado «Contacto · con número de pedido» del Figma). Oculto queda deshabilitado
   para que no viaje vacío en el correo. Delegado en document: sobrevive a las
   recargas de la sección en el editor. */
(() => {
  if (window.onContactOrderField) return;
  window.onContactOrderField = true;

  const sync = (select) => {
    const field = document.getElementById(select.getAttribute('aria-controls'));
    if (!field) return;
    const open = select.value !== '' && select.value === select.dataset.orderReason;
    field.hidden = !open;
    field.querySelectorAll('input').forEach((input) => {
      input.disabled = !open;
    });
  };

  const syncAll = () => document.querySelectorAll('select[data-order-reason]').forEach(sync);

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('select[data-order-reason]');
    if (select) sync(select);
  });

  // el navegador puede devolver el motivo elegido al volver a la página
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  window.addEventListener('pageshow', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
})();
